import { AppSelector } from 'app/store'
import getDataSelector from 'core/utils/getDataSelector'
import { createSharedSelector } from 'core/utils/selectorHelpers'
import DataKeys from 'k8s/DataKeys'
import { NEW_CLUSTER_NODE_LABEL } from './actions'

export const UNASSIGNED_CLUSTER_NAME = 'Not Assigned'

export const physicalNodeSelector: AppSelector<any[]> = createSharedSelector(
  getDataSelector<DataKeys.KaapiBYOHosts>(DataKeys.KaapiBYOHosts),
  getDataSelector<DataKeys.KaapiBYOMachines>(DataKeys.KaapiBYOMachines),
  (physicalNodes, byoMachines): any[] => {
    return physicalNodes.map((physicalNode) => {
      const byoMachine = byoMachines.find(
        (machine) => machine?.metadata?.name === physicalNode?.status?.machineRef?.name,
      )

      const defaultNetwork = physicalNode?.status?.network?.find((s) => s.isDefault === true)
      const hostStatus = defaultNetwork?.connected ? 'Connected' : 'Disconnected'
      const ipAddresses = defaultNetwork?.ipAddrs

      return {
        name: physicalNode?.metadata?.name,
        uid: physicalNode?.metadata?.uid,
        namespace: physicalNode?.metadata?.namespace,
        hostStatus,
        ipAddresses,
        byoMachine,
        clusterName:
          byoMachine?.metadata?.labels?.['cluster.x-k8s.io/cluster-name'] ||
          physicalNode?.metadata?.labels?.[NEW_CLUSTER_NODE_LABEL] ||
          UNASSIGNED_CLUSTER_NAME,
        ...physicalNode,
      }
    })
  },
)
